import { Col, Modal, theme, Typography } from "antd";
import { useState } from "react";
import { resetPasswordForUser } from "../repository/auth.repository";
import ModalFooter from "../controls/ModalFooter";
import ModalErrorAlert from "../controls/ModalErrorAlert";
import { getProblemMessage } from "../utils/http";

export interface ResetUserProps {
  readonly open?: boolean;
  readonly initialValues: {
    readonly userUid: string;
    readonly userName: string;
  };
  readonly onFinish?: () => void;
  readonly onCancel?: () => void;
}

function ResetUserFormDialog(props: ResetUserProps) {
  const { token } = theme.useToken();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  function onSubmit(): void {
    setLoading(true);
    setErrorMessage("");
    resetPasswordForUser(props.initialValues.userUid)
      .then(() => {
        setLoading(false);
        props.onFinish?.();
      })
      .catch((err) => {
        setLoading(false);
        // R2: surface the backend problem-detail (e.g. "The request is invalid.") so an operator can tell
        // "user has no email" from "user has no role" from a network failure, instead of a blanket toast.
        setErrorMessage(getProblemMessage(err));
      });
  }

  function onCancel(): void {
    props.onCancel?.();
  }

  return (
    <Modal
      open={props.open}
      centered
      title={"Reset Password"}
      footer={null}
      maskClosable={false}
      onCancel={onCancel}
    >
      <Col className="flex max-h-[512px] w-[720px] flex-col overflow-hidden overflow-y-auto">
        <Typography.Paragraph>
          <Typography.Text>
            Continue sending reset password request for{" "}
            <Typography.Text className="font-bold">
              {props.initialValues?.userName}
            </Typography.Text>{" "}
            user?
          </Typography.Text>
        </Typography.Paragraph>
        <ModalErrorAlert message={errorMessage} />
        {/* Actions */}
        <div className="sticky bottom-0 flex flex-row items-center justify-end">
          <ModalFooter
            mode="delete"
            loading={loading}
            onCancel={onCancel}
            onSubmit={onSubmit}
            submitText="Send Request"
          />
        </div>
      </Col>
    </Modal>
  );
}

export default ResetUserFormDialog;
